import { Close } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { GetChannels } from "contexts/ChannelsContext";
import { saveMap } from "data/functions";
import SbpLogoWithText from "data/images/sbp2.svg";
import SbpLogoWhite from "data/images/sbp_white.svg";
import React from "react";

export function ChannelField(props) {
  const { changeStatus, channels, statuses } = GetChannels();
  const theme = useTheme();
  return (
    <React.Fragment>
      <Typography
        sx={{ color: theme?.palette?.text?.secondary, fontSize: "0.75rem" }}
      >
        Каналы
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "6px",
        }}
      >
        {saveMap(channels, "SettingBody.ChannelsField").map((item, index) => {
          let status = statuses ? statuses[item?.id] : true;
          return (
            <Box
              key={index}
              onClick={() => {
                // if (item?.id !== "Default")
                changeStatus(item?.id);
              }}
              sx={{
                alignItems: "center",
                background:
                  item?.id === "Default"
                    ? theme?.palette?.action?.selected
                    : undefined,
                border:
                  item?.id !== "Default" ? "1px dashed grey" : "1px solid grey",
                cursor: item?.id !== "Default" ? "pointer" : undefined,
                display: "flex",
                height: "48px",
                justifyContent: "center",
                position: "relative",
                width: "48px",
              }}
            >
              {status === false && (
                <Box
                  sx={{
                    alignItems: "center",
                    background: "#bdbdbd45",
                    display: "flex",
                    height: "100%",
                    justifyContent: "center",
                    position: "absolute",
                    width: "100%",
                  }}
                >
                  <Close />
                </Box>
              )}
              <img
                alt={item?.id}
                src={
                  item?.id !== "Default"
                    ? item?.logo
                    : theme?.palette?.mode === "light"
                    ? SbpLogoWithText
                    : SbpLogoWhite
                }
                style={{
                  height: "auto",
                  maxWidth: "80%",
                  opacity: status === false ? 0.2 : 1,
                  padding: "0.4rem",
                }}
              />
            </Box>
          );
        })}
      </Box>
    </React.Fragment>
  );
}
